import React from "react";
import {
  allExpanded,
  defaultStyles,
  JsonView,
  Props,
} from "react-json-view-lite";

import { Box } from "@mui/material";

import "react-json-view-lite/dist/index.css";

type JsonProps = { data: object; name?: string };

//@ts-ignore
export const JsonComponent = (props: JsonProps & Partial<Props>) => {
  const { data, name, ...rest } = props;
  return (
    <Box className="json-view-container">
      <JsonView data={data} shouldExpandNode={allExpanded} {...rest} />
    </Box>
  );
};

export const Json = React.memo(JsonComponent);
